import { Typography, Stepper, Step, StepLabel, Button } from "@mui/material";
import React, { useState } from "react";
import DemoStep6 from "../../components/add-store-steps/DemoSte6";
import DemoStep2 from "../../components/add-store-steps/DemoStep2";
import DemoStep3 from "../../components/add-store-steps/DemoStep3";
import DemoStep4 from "../../components/add-store-steps/DemoStep4";
import DemoStep5 from "../../components/add-store-steps/DemoStep5";
import DemoStep7 from "../../components/add-store-steps/DemoStep7";
import OtpVerification2 from "../../Modals/optVerification";
import SuccessVendorForm from "../../Modals/sucessVendorForm";

export default function StoreSteps() {
  const [activeStep, setActiveStep] = useState(0);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const steps = [
    "Step 2",
    "Step 3",
    "Step 4",
    "Step 5",
    "Step 6",
    "Step 7",
  ];

  const handleNext = () => {
  

    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleReset = () => setActiveStep(0);

  const handleOtpVerified = () => {
    setOpenOtpModal(false);
    setActiveStep(1);
  };

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <DemoStep2 />;
      case 1:
        return <DemoStep3 />;
      case 2:
        return <DemoStep4 />;
      case 3:
        return <DemoStep5 />;
      case 4:
        return <DemoStep6 />;
      case 5:
        return <DemoStep7 />;

      default:
        return <Typography>Unknown Step</Typography>;
    }
  };

  return (
    <>
      <section className="wrap_viewDemo_steps uh_spc">
        <div className="container">
          <div className="page_head">
            <p>
              <figure><img src="/static/images/ai_icon.svg" alt="Icon" /></figure>
              <strong>Let’s get to Know Your Brand</strong>
              <span>Tell us a little about your business to begin your Bouteek journey.
              </span>
              <strong>Before you continue, please have your valid UAE Trade License ready for upload.
              </strong>

            </p>
          </div>

          <div className="steps_grid">
            <div className="step_lt">
              <Stepper activeStep={activeStep} orientation="horizontal">
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel></StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>

            <div className="step_rt">
              <div className="shadow_box">
                {activeStep === steps.length ? (
                  <div className="completed_step">
                    <Typography>All steps completed - you're finished!</Typography>
                    <Button onClick={handleReset} sx={{ mt: 2 }}>
                      Reset
                    </Button>
                  </div>
                ) : (
                  <>
                    {renderStepContent(activeStep)}

                    <div className="btn_flex">
                      <Button
                        className="btn btn_grey"
                        onClick={handleBack}
                        disabled={activeStep === 0}
                      >
                        Back
                      </Button>

                      {activeStep === steps.length - 1 ? (
                        <Button className="btn btn_primary" onClick={() => setOpenSuccessModal(true)}>
                          <img src="/static/images/ai_icon.svg" alt="Icon" /> Submit for review
                        </Button>
                      ) : (
                        <Button className="btn btn_primary" onClick={handleNext}>Next</Button>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <OtpVerification2
        open={openOtpModal}
        onClose={() => setOpenOtpModal(false)}
        setOpen={setOpenOtpModal}
        onVerify={handleOtpVerified} // <-- pass callback here
      />

      <SuccessVendorForm
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        setOpen={setOpenSuccessModal}
      />
    </>
  );
}
